(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["fh-cart-upsell"] && !Shopify.designMode) return;
  try {
    /* Eigenes Element statt eines Beobachters: der Drawer wird bei jeder
     Warenkorbaenderung neu gerendert, und ein frisch eingesetztes
     <fh-upsell-slider> ruft connectedCallback von sich aus auf. */
  class FhUpsellSlider extends HTMLElement {
    connectedCallback() {
      this.viewport = this.querySelector('.fh-upsell__viewport');
      this.pages = Array.from(this.querySelectorAll('.fh-upsell__page'));
      this.dots = Array.from(this.querySelectorAll('.fh-upsell__dot'));
      if (!this.viewport || this.pages.length < 2) return;

      this.index = 0;
      // Ab drei Seiten steht die aktuelle in der Mitte - dann gibt es links UND
      // rechts eine Nachbarseite und das Wischen laeuft in beide Richtungen im
      // Kreis. Bei genau zwei Seiten ist das nicht moeglich, ohne eine davon zu
      // doppeln; dort steht die aktuelle vorn.
      this.home = this.pages.length >= 3 ? 1 : 0;
      this.lock = false;
      this.width = 0;

      this.onClick = this.onClick.bind(this);
      this.onScroll = this.onScroll.bind(this);
      this.addEventListener('click', this.onClick);
      this.viewport.addEventListener('scroll', this.onScroll, { passive: true });

      /* Der Drawer ist beim Rendern zu, das Fenster also 0 px breit - jede
         Rechnung mit clientWidth ginge daneben. Der Beobachter holt das nach,
         sobald der Drawer aufgeht, und faengt spaeter Drehungen des Geraets. */
      this.observer = new ResizeObserver(() => {
        const w = this.viewport.clientWidth;
        if (w && w !== this.width) {
          this.width = w;
          this.layout();
        }
      });
      this.observer.observe(this.viewport);
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
      clearTimeout(this.timer);
    }

    /* Vergibt die Plaetze neu und setzt das Fenster ohne Animation auf den
       Platz der aktuellen Seite. Sichtbar aendert sich dabei nichts - die
       Seite, die vorher unter dem Fenster lag, liegt danach immer noch dort. */
    layout() {
      const n = this.pages.length;
      this.pages.forEach((page, k) => {
        page.style.order = String((k - this.index + this.home + n + n) % n);
      });
      this.dots.forEach((dot, i) => {
        if (i === this.index) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });

      this.lock = true;
      this.viewport.scrollTo({ left: this.home * this.viewport.clientWidth, behavior: 'auto' });
      requestAnimationFrame(() => {
        requestAnimationFrame(() => { this.lock = false; });
      });
    }

    onScroll() {
      if (this.lock) return;
      clearTimeout(this.timer);
      // Kein scrollend-Ereignis: es fehlt in aelteren Safari-Fassungen.
      this.timer = setTimeout(() => this.settle(), 140);
    }

    settle() {
      const w = this.viewport.clientWidth;
      if (!w) return;
      const delta = Math.round(this.viewport.scrollLeft / w) - this.home;
      if (!delta) return;
      const n = this.pages.length;
      this.index = ((this.index + delta) % n + n) % n;
      this.layout();
    }

    go(dir) {
      const w = this.viewport.clientWidth;
      if (!w) return;
      let slot = this.home + dir;
      // Bei zwei Seiten fuehren vor und zurueck auf dieselbe Nachbarseite.
      if (slot < 0 || slot > this.pages.length - 1) slot = this.home - dir;
      this.viewport.scrollTo({ left: slot * w, behavior: 'smooth' });
    }

    goTo(target) {
      const n = this.pages.length;
      const delta = ((target - this.index) % n + n) % n;
      if (!delta) return;
      if (delta === 1) return this.go(1);
      if (delta === n - 1) return this.go(-1);
      this.index = target;
      this.layout();
    }

    onClick(event) {
      const arrow = event.target.closest('[data-fh-slide]');
      if (arrow) {
        this.go(Number(arrow.dataset.fhSlide));
        return;
      }
      const dot = event.target.closest('[data-fh-dot]');
      if (dot) this.goTo(Number(dot.dataset.fhDot));
    }
  }

  if (!customElements.get('fh-upsell-slider')) {
    customElements.define('fh-upsell-slider', FhUpsellSlider);
  }

  // Ein delegierter Listener fuer alle Zeilen.
  document.addEventListener('click', (event) => {
    const toggle = event.target.closest('.fh-upsell__toggle');
    if (toggle) {
      const panel = document.getElementById(toggle.dataset.fhToggle);
      if (!panel) return;
      const open = toggle.getAttribute('aria-expanded') === 'true';

      // Andere Zeilen schliessen, damit die Liste kompakt bleibt.
      const list = toggle.closest('.fh-upsell');
      if (list && !open) {
        list.querySelectorAll('.fh-upsell__toggle[aria-expanded="true"]').forEach((other) => {
          other.setAttribute('aria-expanded', 'false');
          const otherPanel = document.getElementById(other.dataset.fhToggle);
          if (otherPanel) otherPanel.hidden = true;
        });
      }

      toggle.setAttribute('aria-expanded', String(!open));
      panel.hidden = open;
      return;
    }

    const variant = event.target.closest('.fh-upsell__variant');
    if (!variant || variant.disabled) return;

    const form = variant.closest('form');
    if (!form) return;

    const input = form.querySelector('input[name="id"]');
    const submit = form.querySelector('.fh-upsell__submit');
    if (!input || !submit) return;

    input.value = variant.dataset.fhVariant;
    submit.click();
  });
  } catch(e) { console.error(e); }
})();

})();
